import moment from 'moment';

export const ageCalculation = (currentDate) => {

    if (currentDate && moment(currentDate).isSameOrBefore(new Date())) {
        return Math.ceil(moment().diff(`${currentDate}`, 'years', true));
    }
    return null;

}